{
    "21MMvI7yiQk-eWt-XzCCh": {
        "key": "21MMvI7yiQk-eWt-XzCCh",
        "position": {
            "x": 14,
            "y": 19,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "c0Rfv2wmNvW_qWPvYHcqI": {
        "key": "c0Rfv2wmNvW_qWPvYHcqI",
        "position": {
            "x": 13,
            "y": 19,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "iUuOP6vdeJOppow6IsEME": {
        "key": "iUuOP6vdeJOppow6IsEME",
        "position": {
            "x": 16,
            "y": 19,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "RfFs6gcj04zVU_27wlvxW": {
        "key": "RfFs6gcj04zVU_27wlvxW",
        "position": {
            "x": 15,
            "y": 19,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "d2hEYy9MbtXn5r4BA6B0a": {
        "key": "d2hEYy9MbtXn5r4BA6B0a",
        "position": {
            "x": 14,
            "y": 11,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "EUShZBk5p_14xdrmargAk": {
        "key": "EUShZBk5p_14xdrmargAk",
        "position": {
            "x": 14,
            "y": 10,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "xKUdK5vCDli4gw_XJtpC7": {
        "key": "xKUdK5vCDli4gw_XJtpC7",
        "position": {
            "x": 15,
            "y": 10,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "5Q7eKwCEZwtY_AzbA7ixb": {
        "key": "5Q7eKwCEZwtY_AzbA7ixb",
        "position": {
            "x": 15,
            "y": 11,
            "z": 1
        },
        "tag": "spawnspot"
    }
}